import React, { useContext } from 'react';
import styled from "@emotion/styled";
import DOMPurify from 'dompurify';
import { QuizContext } from "./ConfigurableQuizContainer";
import PostRenderedTracking from '../../../common/post-rendered-tracking';

export default function ElementHTML({
    content,
    tag,
    styling,
    className
  }) {

  function doClicks(e) {
    if (e.target.tagName == "A") {
      PostRenderedTracking.track(e);
    }
  }

  const { firstName } = useContext(QuizContext);

  let cleanedHTML = DOMPurify.sanitize(content, { ADD_ATTR: ['target'] });

  // find any [[{firstName}|fallback]] values in the strings
  const nameMatches = cleanedHTML.match(/\[\[(.*?)\]\]/g);
  if (nameMatches) {
    nameMatches.forEach(nameMatch => {
      let replacer = '';
      let pairFinder = nameMatch.replaceAll(/[[\]]/g, '').split('|');
      let namePiece = pairFinder[0];
      let fallbackPiece = pairFinder[1] ? pairFinder[1] : '';
      if (firstName) {
        replacer = namePiece.replace(/\{firstName\}/g, firstName);
      } else {
        replacer = fallbackPiece;
      }
      cleanedHTML = cleanedHTML.replace(nameMatch, replacer);
    })
  }


  const CustomTag = `${tag ? tag : 'div'}`;
  const StyledEl = styled[CustomTag]`${styling}`;

  return (
    <StyledEl onClick={doClicks} dangerouslySetInnerHTML={{__html: cleanedHTML}} className={className} />
  )
}

